import React, { memo } from 'react';
import HmsRemoteVideo from './hmsRemoteVideo';
import TokboxRemoteVideo from './tokboxRemoteVideo';
const AVRemoteVideo = ({ peer, videoType, initialAudioVolume, subscribeToVideo, }) => {
    const { provider, av, screen } = peer;
    if (provider === 'tokbox') {
        if (videoType === 'camera') {
            return av?.stream ? (React.createElement(TokboxRemoteVideo, { key: peer.id, videoStream: av.stream, initialAudioVolume: initialAudioVolume, subscribeToVideo: subscribeToVideo })) : null;
        }
        if (videoType === 'screen') {
            return screen?.stream ? (React.createElement(TokboxRemoteVideo, { key: peer.id, videoStream: screen.stream, initialAudioVolume: initialAudioVolume, subscribeToVideo: subscribeToVideo })) : null;
        }
    }
    if (provider === '100ms') {
        if (videoType === 'camera' && av?.videoTrack) {
            return (React.createElement(HmsRemoteVideo, { key: peer.id, videoTrack: av.videoTrack, subscribeToVideo: subscribeToVideo }));
        }
        if (videoType === 'screen' && screen?.videoTrack) {
            return (React.createElement(HmsRemoteVideo, { key: peer.id, videoTrack: screen.videoTrack, subscribeToVideo: subscribeToVideo }));
        }
    }
    return null;
};
export default memo(AVRemoteVideo);
//# sourceMappingURL=index.js.map